// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__52oEY","tyre":"style_tyre__ykdua"};